import { getName, getNames, registerLocale, getAlpha2Code } from '@cospired/i18n-iso-languages'

registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'))

export const languagesList = getNames('en')
